module.exports = __webpack_public_path__ + "static/img/chengxin.50d47a9e.png";